import { Model } from 'backbone';

class LeagueFilterModel extends Model {

	defaults() {
		return {
			filter:      '',
			skill_level: '',
			size:        '',
			size_list:   [ 6, 8, 10, 12, 14, 16, 18, 20 ],
		};
	}
}

export default LeagueFilterModel;